<template>
  <div style="height: 100%;position:relative;">
    <layout-header>
      <slot name="header-right" />
      <template slot="title">
        <slot name="headerTitle" />
      </template>
    </layout-header>
    <layout-menu v-model="isCollapse" :menu-list="menuList" :class="{'isCollapse':isCollapse}" @customer-call="$emit('customer-call')" />
    <div class="rj-layout-main" :class="{'isCollapse':isCollapse}">
      <el-scrollbar id="routerScroll">
        <slot />
      </el-scrollbar>
    </div>
  </div>
</template>
<script type="es6">
import LayoutHeader from './layoutheader';
import LayoutMenu from './layoutmenu';
export default {
  name: 'RjLayout',
  props: {
    menuList: {
      type: Array,
      default: () => { return []; }
    }
  },
  data () {
    return {
      isCollapse: false
    };
  },
  components: {
    LayoutHeader,
    LayoutMenu
  },
  computed: {
  },
  methods: {},
  mounted () {
  }
};
</script>
<style lang="scss">
  @import "../../style/var";
  @include namespace(layout-main){
    position: absolute;
    left: $layoutMenuWidth;
    right: 0;
    top: $layoutHeaderHeight;
    bottom: 0;
    overflow: hidden;
    transition: left .3s ease-in-out;
    &.isCollapse{
      left: 64px;
    }
    .el-scrollbar {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      bottom: 0;
      .el-scrollbar__wrap {
        overflow-x: hidden;
      }
    }
  }
  .iconfont.icon-keqi{
    font-size: 14px;
  }
</style>
